import React from 'react';
import { BookOpenIcon, SparklesIcon, TagIcon, TypeIcon, WrenchIcon } from 'lucide-react';
const results = [{
  icon: BookOpenIcon,
  value: '6',
  label: 'Tomos Premium'
}, {
  icon: SparklesIcon,
  value: '+100',
  label: 'Rituales aromáticos listos para implementar'
}, {
  icon: TagIcon,
  value: '+120',
  label: 'Nombres premium para tus productos'
}, {
  icon: TypeIcon,
  value: '+300',
  label: 'Palabras sensoriales para vender mejor'
}, {
  icon: WrenchIcon,
  value: '+80',
  label: 'Plantillas, checklists y herramientas'
}];
export function WhatIsIt() {
  return <section className="w-full bg-[#f7f3ec] px-5 py-14" data-id="element-250" data-mp="71lk1qmd95ss">
      <div className="mx-auto max-w-md text-center" data-id="element-251" data-mp="70sid429l6hi">
        <h2 className="font-serif-display text-3xl font-bold leading-tight text-[#3b3350]" data-id="element-252" data-mp="c0f0nrwy9cx6">
          ¿Qué es realmente la Biblioteca de Rituales Aromáticos™?
        </h2>

        <div className="mt-6 space-y-2 text-sm text-[#7a7288]" data-id="element-253" data-mp="zo6dqxqbdtzi">
          <p data-id="element-254" data-mp="14hrakmg68hx4">No es un ebook. No es una colección de recetas. No es otro curso lleno de teoría.</p>
        </div>

        <p className="mt-5 text-base leading-relaxed text-[#5a5266]" data-id="element-255" data-mp="3g1uqkuv2jnfk">
          Es un <span className="font-semibold text-[#3b3350]" data-id="element-256" data-mp="3c0rcodwl01gz">sistema práctico y accionable</span> para
          transformar cualquier producto aromático en una experiencia que aumenta su valor percibido.
        </p>

        <div className="mt-8 rounded-2xl bg-[#3b3350] p-5 text-white" data-id="element-257" data-mp="3kzmn626nrxq3">
          <p className="mb-4 text-xs font-semibold uppercase tracking-widest text-[#c9b8ea]" data-id="element-258" data-mp="3j517h101u7r">
            Un sistema completo que incluye
          </p>
          <div className="space-y-2.5" data-id="element-259" data-mp="3usbs0e7pedcg">
            {results.map(r => <div key={r.label} className="flex items-center gap-3 rounded-xl bg-white/5 p-3 text-left ring-1 ring-white/10" data-id="element-260" data-mp="ck2vh7lmynd5">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-[#7c6aa8]" data-id="element-261" data-mp="2eb69m6uqik2g">
                  <r.icon className="w-5 h-5 text-white" data-id="element-262" data-mp="29e6c4kbyapmy" />
                </span>
                <p className="text-sm leading-tight" data-id="element-263" data-mp="dajhfo3rguvi">
                  <span className="font-serif-display text-xl font-bold text-[#e6d3ae]" data-id="element-264" data-mp="dbuhpdxzzkhv">{r.value}</span>{' '}
                  {r.label}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}